module.exports = __webpack_public_path__ + "img/modal-member.1b84abfc.svg";